import { render, staticRenderFns } from "./objectDialog.vue?vue&type=template&id=38f0908a&"
import script from "./objectDialog.vue?vue&type=script&lang=js&"
export * from "./objectDialog.vue?vue&type=script&lang=js&"
import style0 from "./objectDialog.vue?vue&type=style&index=0&id=38f0908a&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports